<template>
	<div class="home" :class="{ whiteColor: checkColor == 2 }">
		<!-- 地图 -->
		<div id="mapContainer"></div>
		<!-- 头部 -->
		<div class="pagetitle">
			<div class="time">
				{{ time }}
			</div>
			<div class="title-name">秀英区安全生产智慧监管平台</div>
			<!-- 天气 -->
			<div class="wether">
				&nbsp;
				<!-- {{ weatherDetail.weather }} {{ weatherDetail.temperature }}℃ {{ weatherDetail.windDirection }}风
				{{ weatherDetail.windPower }}级 -->
			</div>
		</div>
		<!-- 左侧隐患类型 -->
		<div class="pageleft">
			<div class="list-page-title">隐患类型</div>
			<div class="item" :class="{ active: leftitem == 0 }" v-if="sType == 1" @click="yhqh(1, 0)">
				<i class="iconfont icon-yinhuanguanli" style="font-size: 26px; margin-bottom: 8px"></i>
				近期隐患
				<span class="lxzs" v-if="this.allCount">{{ this.allCount }}</span>
			</div>
			<div class="item" :class="{ active: leftitem == 0 }" @click="yhqiy(1, 0)" v-if="sType == 4">
				<i class="iconfont icon-yinhuanguanli" style="font-size: 26px; margin-bottom: 8px"></i>
				企业/点位
				<span class="lxzs" v-if="this.allCount">{{ this.allCount }}</span>
			</div>

			<template v-if="sType != 4">
				<div
					class="item"
					:class="{ active: leftitem == index + 1 }"
					v-for="(item, index) in typeList"
					@click="yhqh(item, index + 1)"
					:key="index"
				>
					<i class="iconfont" :class="item.kw1" style="font-size: 38px"></i>
					{{ item.kw0 }}
					<span class="lxzs" v-if="item.count">{{ item.count }}</span>
				</div>
			</template>
			<template v-else>
				<div
					class="item"
					:class="{ active: leftitem == index + 1 }"
					v-for="(item, index) in typeList"
					@click="yhqiy(item, index + 1)"
					:key="index"
				>
					<i class="iconfont" :class="item.kw1" style="font-size: 38px"></i>
					{{ item.kw0 }}
					<span class="lxzs" v-if="item.count">{{ item.count }}</span>
				</div>
			</template>
		</div>
		<!-- 左侧四个菜单 -->
		<div class="pages-lef-r">
			<div class="list-page-c">
				<div class="pages-li" :class="{ active: sType == 4 }" @click="editShowType(4)">
					企业或点位管理
				</div>
				<div class="pages-li" :class="{ active: sType == 1 }" @click="editShowType(1)">隐患问题</div>
				<div class="pages-li" :class="{ active: sType == 5 }" @click="editShowType(5)">
					假日防控排班
				</div>
				<div class="pages-li" :class="{ active: sType == 2 }" @click="editShowType(2)">区域管理</div>

				<div class="pages-li" :class="{ active: sType == 3 }" @click="editShowType(3)">处置流程</div>
			</div>
		</div>
		<!-- 右边列表数据 -->
		<div class="pageright">
			<div class="check-btn" :class="{ cactive: yhStu != 1 }" v-if="sType == 1 || sType == 3">
				<div class="btn-l" @click="yhStuCh(1)">整改中</div>
				<div class="btn-r" @click="yhStuCh(2)">已整改</div>
			</div>
			<div class="pglist">
				<div class="pageright-title" v-if="sType == 1 || sType == 3">隐患列表({{ yhALlDetail }}件)</div>
				<div class="pageright-title" v-else-if="sType == 2">区域列表({{ qylist.length }}个)</div>
				<div class="pageright-title" v-else-if="sType == 4">企业/点位列表({{ qiyeAllCount }}家)</div>
				<div class="pageright-title" v-else-if="sType == 5">假日值班点({{ baseList.length }}个)</div>
				<div class="itemlist">
					<div class="search" v-if="sType != 2 && sType != 5">
						<input
							type="text"
							@click="querylistshow = true"
							v-model="querykeyword"
							placeholder="请输入企业或点位"
						/>
						<span @click="select">搜索</span>
						<div class="search-list" v-if="querylistshow && queryName.length">
							<div class="search-li" v-for="(item, index) in queryName" :key="index" @click="seMch(item)">
								{{ item.name }}
							</div>
						</div>
					</div>

					<div class="item list-th">
						<div class="item-nam" v-if="sType == 1 || sType == 3">所属单位</div>
						<div class="item-nam" v-if="sType == 4">企业/点位名称</div>
						<div class="item-nam" v-if="sType == 2">所区域</div>
						<div class="item-nam" v-if="sType == 5">区域/路段</div>
						<div class="item-li" v-if="sType == 5">区领导</div>
						<div class="item-li" v-else>负责人</div>
					</div>

					<div class="allr-list">
						<template v-if="sType == 1 || sType == 3">
							<div
								class="item"
								v-for="(x, index) in yhList"
								:key="index"
								@click="openW(x, index)"
								:class="{ active: rightitem == index }"
							>
								<div class="item-nam">
									{{ x.name }}
									<!-- <span class="dian"></span> -->
								</div>
								<div class="item-li">
									{{ x.kw0 }}
								</div>
							</div>
						</template>
						<template v-else-if="sType == 2">
							<div
								class="item"
								v-for="(x, index) in qylist"
								:key="index"
								@click="openqy(x, index)"
								:class="{ active: rightitem == index }"
							>
								<div class="item-nam">
									{{ x.name }}
								</div>
								<div class="item-li">
									{{ x.kw0 }}
								</div>
							</div>
						</template>
						<template v-else-if="sType == 4">
							<div
								class="item"
								v-for="(x, index) in qiylist"
								:key="index"
								@click="openqiy(x, index)"
								:class="{ active: rightitem == index }"
							>
								<div class="item-nam">
									{{ x.name }}
									<span class="dian" v-if="x.xyz == '110.293561,20.007969'"></span>
								</div>
								<div class="item-li">{{ x.kw0 }}</div>
							</div>
						</template>
						<template v-else-if="sType == 5">
							<div
								class="item"
								v-for="(x, index) in baseList"
								:key="index"
								@click="openJr(x, index)"
								:class="{ active: rightitem == index }"
							>
								<div class="item-nam">
									{{ x.name }}
								</div>
								<div class="item-li">{{ x.kw1 }}</div>
							</div>
						</template>
					</div>
					<div class="yhsb">
						<div class="yhname">移动端二维码</div>
						<div class="yhewm">
							<div class="ewmtp">
								<img style="width: 100%; height: 100%" src="../assets/img/ewm.png" alt="" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 顶部数据统计 -->
		<div class="page-top">
			<div class="item-t item1">
				<div class="titlename">企业/点位 <span style="font-size: 14px">(家/个)</span></div>
				<div class="number">
					<span v-for="(x, index) in topCount.fonre" :key="index">{{ x }}</span>
				</div>
			</div>
			<div class="item-t item2">
				<div class="titlename">上报隐患 <span style="font-size: 14px">(件)</span></div>
				<div class="number">
					<span v-for="(x, index) in topCount.one" :key="index">{{ x }}</span>
				</div>
			</div>
			<div class="item-t item1">
				<div class="titlename">未处理隐患<span style="font-size: 14px">(件)</span></div>
				<div class="number">
					<span v-for="(x, index) in topCount.three" :key="index">{{ x }}</span>
				</div>
			</div>
			<div class="item-t item2">
				<div class="titlename">已处理隐患 <span style="font-size: 14px">(件)</span></div>
				<div class="number">
					<span v-for="(x, index) in topCount.two" :key="index">{{ x }}</span>
				</div>
			</div>
		</div>
		<!-- 底部菜单 -->
		<div class="page-bottom">
			<div class="item-b" v-for="(x, index) in navList" :key="index" @click="bottmCli(x, index)">
				<div class="icon">
					<i class="iconfont" :class="x.icon"></i>
				</div>
				<div class="item-name">{{ x.name }}</div>
			</div>
		</div>
		<!-- echarts 弹出层 -->
		<div class="alertNew" v-if="alertShow">
			<div class="center-alert">
				<div class="alert-title">
					{{ alertTitle }}
					<div class="back-to" @click="alertShow = false">x</div>
				</div>
				<div class="center">
					<line-charts v-if="countType == 0" :datau="echartsMoth" :colorType="checkColor"></line-charts>
					<bar-charts v-if="countType == 1" :datau="echartsType" :colorType="checkColor"></bar-charts>
					<bar-charts v-if="countType == 2" :datau="echartsArea" :colorType="checkColor"></bar-charts>
					<new-charts
						v-if="countType == 3"
						:datau="echartsTown"
						:alist="arealist"
						:colorType="checkColor"
						@getData="getAreaData"
					></new-charts>
				</div>
			</div>
		</div>
		<!-- 企业隐患列表查询 -->
		<div class="alertNew" v-if="alertListShow">
			<div class="center-alert">
				<div class="alert-title">
					企业隐患列表
					<div class="back-to" @click="alertListShow = false">x</div>
				</div>
				<div class="center">
					<div class="yh-list th">
						<div class="yh-th t1">序号</div>
						<div class="yh-th t2">隐患问题</div>
						<div class="yh-th t3">处理措施</div>
						<div class="yh-th t4">上报时间</div>
						<div class="yh-th t4">处理状态</div>
						<div class="yh-th t5">查看</div>
					</div>
					<div class="yh-all-list" v-if="qyIdListYh.length">
						<div class="yh-list frysil" v-for="(x, index) in qyIdListYh" :key="index">
							<div class="yh-th t1">{{ index + 1 }}</div>
							<div class="yh-th t2">{{ x.htmldata }}</div>
							<div class="yh-th t3">{{ x.kw8 }}</div>
							<div class="yh-th t4">{{ x.createtime.substring(0, 11) }}</div>
							<div class="yh-th t4" style="text-align: center">
								<span v-if="x.kw6 == '整改中'" style="color: #fad514">整改中</span>
								<span v-if="x.kw6 == '已整改'" style="color: #21e0ba">已整改</span>
							</div>
							<div class="yh-th t5" @click="todata(x)" style="cursor: pointer; text-align: center">
								详情
							</div>
						</div>
					</div>
					<div class="noneData" v-else>暂无隐患数据</div>
				</div>
			</div>
		</div>
		<!-- 应急预案 -->
		<div class="alertNew" v-if="alertShow1">
			<div class="center-alert small">
				<div class="alert-title">
					类型预案
					<div class="back-to" @click="alertShow1 = false">x</div>
				</div>
				<div class="center">
					<div class="yan-title">一、预案流程</div>
					<div class="yan-lc">
						<span>1.隐患排查</span>
						<i class="iconfont icon-arrow-"></i>
						<span>2.短信通知</span>
						<i class="iconfont icon-arrow-"></i>
						<span>3.电话通知</span>
						<i class="iconfont icon-arrow-"></i>
						<span>4.现场督办</span>
						<i class="iconfont icon-arrow-"></i>
						<span>5.联合执法</span>
					</div>
					<div class="yan-title">二、类型说明</div>
					<div class="yan-lc">
						<div v-for="(x, index) in typeList" :key="index">
							{{ index + 1 }}.{{ x.kw0 }}（ {{ x.name }} ）
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 企业隐患详情 -->
		<div class="alertNew" style="z-index: 9999999" v-if="qyyhdata">
			<div class="center-alert small">
				<div class="alert-title">
					企业隐患详情
					<div class="back-to" @click="qyyhdata = false">x</div>
				</div>
				<div class="center">
					<div class="detail-center">
						<div class="line-heu title">{{ qyyhDetail.name }}</div>
						<div class="line-heu">主要负责人：{{ qyyhDetail.kw0 }}</div>
						<div class="line-heu">联系电话：{{ qyyhDetail.kw1 }}</div>
						<div class="line-heu">隐患时间：{{ qyyhDetail.createtime }}</div>
						<div class="line-heu">详细地址：{{ qyyhDetail.address }}</div>
						<div class="line-heu">隐患类型：{{ qyyhDetail.kw7 }}</div>
						<div class="">
							<div>隐患问题以及描述:</div>
							<div>
								<div>
									{{ qyyhDetail.createtime }}
									{{ qyyhDetail.htmldata }}
								</div>
								<img
									v-for="(item, index) in qyyhDetail.photo"
									:key="index"
									style="width: 120px; height: 120px; margin-left: 8px"
									:src="item"
									alt=""
									srcset=""
								/>
							</div>
						</div>
						<div class="line-heu">整改措施：{{ qyyhDetail.kw8 }}</div>
						<div class="line-heu">整改期限：{{ qyyhDetail.kw2 }}</div>
						<div class="line-heu">整改状态：{{ qyyhDetail.kw6 }}</div>
						<div class="" v-show="qyyhDetail.kw9">
							<div>已整改图片:</div>
							<div>
								<img
									v-for="(item, index) in qyyhDetail.kw9"
									:key="index"
									style="width: 120px; height: 120px; margin-left: 8px"
									:src="item"
									alt=""
									srcset=""
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="ctrl">
			<div @click="tMap.zoomIn()">+</div>
			<div @click="tMap.zoomOut()">-</div>
		</div>
		<!-- 皮肤颜色切换 -->
		<div class="check-color">
			<div class="chack-color-li" @click="hanlderColor(1)">
				<span class="check-or" :class="{ active: checkColor == 1 }"></span>
				<span>暗色系</span>
			</div>
			<div class="chack-color-li" @click="hanlderColor(2)">
				<span class="check-or" :class="{ active: checkColor == 2 }"></span>
				<span>亮色系</span>
			</div>
		</div>
		<loading ref="loading" />
	</div>
</template>

<script>
	import { getTime } from '@/utils/utils'
	import areapath from '../assets/js/xypath'
	import '../assets/iconfont/iconfont.css'
	import Vue from 'vue/dist/vue.js'

	import arealist from '../assets/js/area'
	// import {getFlCount,getFlData,getCount} from "@/service/index";
	import { lx, lxtj, tj, yh, qy, qytj, mothEcharts, typeEcharts, qyEcharts } from '@/api/index'
	import barCharts from './components/qycount.vue'
	import lineCharts from './components/yhsxCount.vue'
	import newCharts from './components/newindex.vue'
	const baseParam = {
		m: process.env.VUE_APP_APPID,
		state: szblMCom.getState(),
		appid: process.env.VUE_APP_APPID,
		rpflag: process.env.VUE_APP_RPFLAG
	}
	import jj from '@/assets/img/yj.png'
	// const jj = require('../../src/assets/img/yj.png')
	import { qiyeMap, alertMap, alertMapQy, alertMapJr } from '@/utils/mapAlert.js'
	import { baseList } from '@/utils/base.js'
	import Loading from './components/loading.vue'
	export default {
		name: 'home',
		components: { lineCharts, barCharts, newCharts, Loading },
		data: function () {
			return {
				qiylist: [],
				colors: ['#37a2da', '#32c5e9', '#ffdb5c'],
				ListMarker: [],
				countType: 1,
				MarkerName: '',
				baseList,
				alertListShow: false,
				MarkerRemarker: '',
				remarkList: [],
				qiyeAllCount: 0,
				imgsu: require('../../src/assets/img/yj.gif'),
				remarkrz: undefined,
				testMarker: '',
				qylist: arealist.xyArea,
				querykeyword: '',
				alertTitle: '统计分析',
				objData: {},
				list: arealist,
				typeList: [],
				alertShow1: false,
				yhList: [],
				yhALlDetail: 0,
				sType: 4,
				alertShow: false,
				leftitem: 0,
				allCount: 0,
				topCount: {},
				flNameList: [],
				pqlistName: [],
				qyNameList: [],
				listName: [],
				queryName: [],
				yhStu: 1,
				querylistshow: false,
				navList: [
					{
						icon: 'icon-yinhuanguanli',
						name: '隐患时段分析'
					},
					{
						icon: 'icon-x_nav_quyufenxi',
						name: '隐患数量分析'
					},
					{
						icon: 'icon-icon_duohangyeshujufugaimianguang',
						name: '区域数量分析'
					},
					{
						icon: 'icon-gongjifenxitupugongjihangweiqushifenxi',
						name: '区域效率分析'
					},
					{
						icon: 'icon-cms',
						name: '数据管理后台'
					}
				],
				rightitem: 0,
				time: '',
				markersList: [],
				lxId: '',
				series: [],
				checkColor: 1,
				qyIdListYh: [],
				qyyhdata: false,
				qyyhDetail: null,
				echartsMoth: null,
				echartsType: null,
				echartsArea: null,
				echartsTown: null,
				arealist: [],
				tMap: ''
			}
		},
		watch: {
			querykeyword(val) {
				// if (val == "") {
				//   this.initqiy();
				//   return;
				// }
				this.queryWordQiy()
			}
		},
		mounted() {
			this.getDevToken()
			this.qylist = arealist.xyArea
			for (let item of arealist.xyArea) {
				this.pqlistName.push(item.name)
			}
			// window.clickHand = this.openWindowClick;
			this.tMap = new T.Map('mapContainer', {
				zoom: 11.9,
				center: new T.LngLat(110.293561, 19.867969)
			})
		},
		async created() {
			await this.$nextTick()
			this.$refs.loading.show()
			setInterval(() => {
				this.time = getTime()
			}, 1000)
		},
		methods: {
			getAreaData(pid) {
				console.log(pid)
				this.getTypeEcharts(pid).then(res => {
					this.echartsTown = res
				})
			},
			getEcharts() {
				return new Promise((resolve, reject) => {
					szblMCom
						.ajaxGet(mothEcharts, {
							tk: szblMCom.token,
							...baseParam,
							year: new Date().getFullYear()
						})
						.then(res => {
							const data = JSON.parse(res.data)
							this.echartsMoth = data
							console.log(data)
							resolve()
						})
				})
			},
			getAreaList() {
				return new Promise((reolve, reject) => {
					szblMCom
						.ajaxGet('/api/areas/460105/subs', {
							tk: szblMCom.token,
							...baseParam,
							psize: 100,
							pnum: 1
						})
						.then(dataJson => {
							const data = JSON.parse(dataJson.data)
							this.arealist = data
							reolve()
						})
				})
			},
			getTypeEcharts(pid) {
				return new Promise((resolve, reject) => {
					szblMCom
						.ajaxGet(typeEcharts, {
							tk: szblMCom.token,
							...baseParam,
							areacode: pid
						})
						.then(res => {
							const data = JSON.parse(res.data)
							const typeList = []
							const allNum = []
							const oneNum = []
							const twoNum = []
							for (let i = 0; i < data.length; i++) {
								typeList.push(data[i].name)
								allNum.push(data[i].data[0])
								oneNum.push(data[i].data[1])
								twoNum.push(data[i].data[2])
							}
							const newData = {
								name: typeList,
								data: [
									{
										name: '总隐患',
										data: allNum,
										itemColor: '#0e9cff'
									},
									{
										name: '未整改隐患',
										data: oneNum,
										itemColor: '#fad514'
									},
									{
										name: '已整改隐患',
										data: twoNum,
										itemColor: '#21e0ba'
									}
								]
							}
							// console.log("---", data);
							resolve(newData)
						})
				})
			},
			getAreaEcharts(pid) {
				return new Promise((resolve, reject) => {
					szblMCom
						.ajaxGet(qyEcharts, {
							tk: szblMCom.token,
							...baseParam,
							pareacode: pid
						})
						.then(res => {
							const data = JSON.parse(res.data)
							const areaList = []
							const allNum = []
							const oneNum = []
							const twoNum = []
							for (let i = 0; i < data.length; i++) {
								areaList.push(data[i].name)
								allNum.push(data[i].data[0])
								oneNum.push(data[i].data[1])
								twoNum.push(data[i].data[2])
							}
							const newData = {
								name: areaList,
								data: [
									{
										name: '总隐患',
										data: allNum,
										itemColor: '#0e9cff'
									},
									{
										name: '未整改隐患',
										data: oneNum,
										itemColor: '#fad514'
									},
									{
										name: '已整改隐患',
										data: twoNum,
										itemColor: '#21e0ba '
									}
								]
							}
							resolve(newData)
						})
				})
			},
			todata(x) {
				let photolist = []
				let photoEdtiList = []
				if (x.photo && x.photo.length) {
					let photo = null
					if (typeof x.photo == 'string') {
						photo = JSON.parse(x.photo)
						for (let i = 0; i < photo.length; i++) {
							photolist.push(szblMCom.urlPrex + photo[i])
						}
						x.photo = photolist
					}
				}
				if (x.kw9 && x.kw9.length) {
					let photo = null
					if (typeof x.kw9 == 'string') {
						photo = JSON.parse(x.kw9)
						for (let i = 0; i < photo.length; i++) {
							photoEdtiList.push(szblMCom.urlPrex + photo[i])
						}
						x.kw9 = photoEdtiList
					}
				}
				this.qyyhDetail = x
				this.qyyhdata = true
			},
			seMch(item) {
				console.log(item)
				this.querykeyword = item.name
				this.queryWordQiy()
				this.querylistshow = false
				if (this.sType == 1 || this.sType == 3) {
					this.initData()
				} else if (this.sType == 4) {
					this.initqiy()
				}
			},
			hanlderColor(x) {
				this.checkColor = x
			},
			yhStuCh(x) {
				this.yhStu = x
				this.initData()
			},
			queryWordQiy() {
				if (this.sType == 1 || this.sType == 3) {
					this.queryYhData({ status: this.yhStu }).then(res => {
						if (res.data) {
							const data = JSON.parse(res.data)
							this.queryName = data
						} else {
							this.queryName = []
						}
					})
				} else if (this.sType == 4) {
					this.getQiyQuery().then(res => {
						if (res.data) {
							const data = JSON.parse(res.data)
							this.queryName = data
						} else {
							this.queryName = []
						}
					})
				}
			},
			select() {
				this.querylistshow = false
				if (this.sType == 1 || this.sType == 3) {
					this.initData()
				} else if (this.sType == 4) {
					this.initqiy()
				}
			},
			async editShowType(i) {
				await this.$nextTick()
				this.$refs.loading.show()
				this.sType = i
				for (let i = 0; i < this.typeList.length; i++) {
					this.typeList[i].count = 0
				}
				if (i == 2) {
					this.qylist = arealist.xyArea
					this.init(arealist.xyArea)
				}
				if (i == 1) {
					this.initData()
					this.getFlCount()
				}
				if (i == 3) {
					this.alertShow1 = true
					this.$refs.loading.hide()
				}
				if (i == 4) {
					this.initqiy()
					this.qiyCount()
				}
				if (i == 5) {
					this.init(baseList)
				}
			},
			getQiyQuery() {
				return new Promise((resolve, reject) => {
					const np = {}
					if (this.lxId) {
						np.gid = this.lxId
					}
					szblMCom
						.ajaxGet(qy, {
							// status: 1,
							tk: szblMCom.token,
							pnum: 1,
							psize: 300,
							querykeyword: this.querykeyword,
							...baseParam,
							orderby_updatetime: 'd_d',
							orderby_createtime: 'd_d',
							...np
						})
						.then(res => {
							resolve(res)
						})
				})
			},
			initqiy() {
				this.$refs.loading.show()
				return this.getQiyQuery().then(res => {
					this.qiyeAllCount = res.num
					if (res.data) {
						const data = JSON.parse(res.data)
						for (let item of data) {
							if (!item.xyz) {
								item.xyz = '110.293561,20.007969'
							}
						}
						this.qiylist = [...data]
						this.init(this.qiylist)
					} else {
						this.qiylist = []
					}
				})
			},
			addQiYMarker(list, map = this.tMap) {
				for (const i of list) {
					const xy = i.xyz.split(',')
					const LngLat = new T.LngLat(xy[0], xy[1])
					const mark = new T.Marker(LngLat, {
						icon: new T.Icon({
							iconUrl: jj,
							iconSize: [40, 40]
						})
					})
					mark.addEventListener('click', async () => {
						map.panTo(LngLat)
						const infoWindow = new T.InfoWindow(await this.setQIYEmap(i))
						infoWindow.addEventListener('open', e => {
							const h = e.target.UT.clientHeight
							infoWindow.setOffset(new T.Point(0, h / 2 + 60))
						})
						mark.openInfoWindow(infoWindow)
					})
					map.addOverLay(mark)
				}
			},
			setQIYEmap(item) {
				return new Promise((t, c) => {
					let oneStatus = 0
					let twoStatus = 0
					this.queryYhData({
						fid: item.id,
						psize: 100
					})
						.then(res => {
							const d = JSON.parse(res.data)
							if (d) {
								for (let item of d) {
									if (item.status == 1) {
										oneStatus += 1
									}
									if (item.status == 2) {
										twoStatus += 1
									}
								}
								this.qyIdListYh = d
							} else {
								this.qyIdListYh = []
							}
							const qydata = {
								oneStatus,
								twoStatus
							}
							const _this = this
							const myComponent = Vue.extend({
								template: qiyeMap(item, qydata),
								methods: {
									moreQy() {
										_this.alertListShow = true
									}
								}
							})
							const component = new myComponent().$mount()
							t(component.$el)
						})
						.catch(err => {
							console.log(err)
							c(err)
						})
				})
			},
			async openWindow(map = this.tMap, item, e, c) {
				let infoWindow = new T.InfoWindow(await this.setQIYEmap(item))
				infoWindow.addEventListener('open', e => {
					const h = e.target.UT.clientHeight
					infoWindow.setOffset(new T.Point(0, h / 2 + 60))
				})
				map.openInfoWindow(infoWindow, new T.LngLat(e.lnglat.lng, e.lnglat.lat))
				// infoWindow.open(map, [e.lnglat.lng, e.lnglat.lat])
				if (c != 0) {
					// map.setZoomAndCenter(16, [e.lnglat.lng, e.lnglat.lat], false, 800)
					map.panTo(new T.LngLat(e.lnglat.lng, e.lnglat.lat))
				}
			},
			allAcountQy() {
				szblMCom
					.ajaxGet(qytj, {
						status: 1,
						tk: szblMCom.token,
						...baseParam,
						gid: this.lxId
					})
					.then(res => {
						const data = JSON.parse(res.data)
						let allCount = 0
						for (let i = 0; i < data.length; i++) {
							allCount = allCount + (data[i].count0 - 0)
						}
						this.$set(this.topCount, 'fonre', this.toBel(allCount))
					})
			},
			qiyCount() {
				return szblMCom
					.ajaxGet(qytj, {
						status: 1,
						tk: szblMCom.token,
						...baseParam
					})
					.then(res => {
						const data = JSON.parse(res.data)
						this.allCount = 0
						if (this.sType != 4) return
						for (let i = 0; i < data.length; i++) {
							this.allCount = this.allCount + (data[i].count0 - 0)
							for (let j = 0; j < this.typeList.length; j++) {
								if (this.typeList[j].id == data[i].yid1) {
									this.typeList[j].count = data[i].count0
								}
							}
						}
					})
			},
			async bottmCli(item, x) {
				console.log('start', x)
				if (x == 0) {
					await this.getEcharts()
				}
				if (x == 1) {
					await this.getTypeEcharts('').then(res => {
						this.echartsType = res
					})
				}
				if (x == 2) {
					await this.getAreaEcharts('460105').then(res => {
						this.echartsArea = res
					})
				}
				if (x == 3) {
					await this.getAreaList()
					await this.getTypeEcharts(this.arealist[0].id).then(res => {
						console.log(res)
						this.echartsTown = res
					})
				}
				if (x == 4) {
					window.open(
						'https://ms.nkshuju.com/Resources/adminNew/customer/index.html#/user/login?appid=460105govszbl15982565522731514202127govszbl202110282142620&apptitle=%E5%AE%89%E5%85%A8%E7%94%9F%E4%BA%A7%E7%AE%A1%E7%90%86%E7%B3%BB%E7%BB%9F'
					)
					return false
				}
				this.alertTitle = item.name
				this.alertShow = true
				this.countType = x

				console.log(this.alertShow)
			},
			getDevToken() {
				const that = this
				szblMCom
					.getTokenFromAppIdAndSecret(process.env.VUE_APP_APPID, process.env.VUE_APP_APPSERETID)
					.then(async res => {
						that.getFl()
						that.initqiy()
						that.getStatusCount()
						that.allAcountQy()
						// this.getAreaList();
						// that.getEcharts();
						// that.initData();
						// that.qiyCount();
					})
			},
			getFlCount() {
				szblMCom
					.ajaxGet(lxtj, {
						status: 1,
						tk: szblMCom.token,
						...baseParam
					})
					.then(res => {
						const data = JSON.parse(res.data)
						this.allCount = 0
						for (let i = 0; i < this.typeList.length; i++) {
							this.typeList[i].count = 0
						}
						for (let i = 0; i < data.length; i++) {
							this.allCount = this.allCount + (data[i].count0 - 0)
							for (let j = 0; j < this.typeList.length; j++) {
								if (this.typeList[j].id == data[i].yid1) {
									this.typeList[j].count = 0
									this.typeList[j].count = data[i].count0
								}
							}
						}
					})
			},
			getStatusCount() {
				szblMCom
					.ajaxGet(tj, {
						status: 1,
						tk: szblMCom.token,
						...baseParam,
						gid: this.lxId
					})
					.then(res => {
						const data = JSON.parse(res.data)
						const all = data.count1 - 0 + (data.count2 - 0)
						this.topCount.one = this.toBel(all)
						this.topCount.two = this.toBel(data.count2)
						this.topCount.three = this.toBel(data.count1)
					})
			},
			toBel(iten) {
				let q = iten + ''
				let newIten = ''
				if (q.length < 4) {
					let add0 = '0'
					for (let i = 0; i < 3 - q.length; i++) {
						add0 = '0' + add0
					}
					newIten = add0 + q
				} else {
					newIten = q
				}
				return newIten
			},
			getFl() {
				return szblMCom
					.ajaxGet(lx, {
						tk: szblMCom.token,
						...baseParam,
						psize: 100,
						gid: 0,
						pnum: 1,
						labelid: '1006019'
					})
					.then(async res => {
						this.flNameList = []
						this.listName = []
						this.series = []
						const data = JSON.parse(res.data)
						for (let item of data) {
							this.listName.push(item.kw0)
							let dataList = []
							for (let i = 0; i < 12; i++) {
								dataList.push(Math.ceil(Math.random() * 30))
							}
							const obj = {
								name: item.kw0,
								data: dataList
							}
							this.flNameList.push(obj)
						}
						this.typeList = data
						await this.qiyCount()

						// this.getFlCount();
					})
			},
			queryYhData(data) {
				return new Promise((resolve, reject) => {
					const np = {}
					if (this.lxId) {
						np.gid = this.lxId
					}
					const u = {
						tk: szblMCom.token,
						...baseParam,
						psize: 100,

						querykeyword: this.querykeyword,
						pnum: 1,
						...np
					}
					const params = Object.assign({}, u, data)
					szblMCom.ajaxGet(yh, params).then(res => {
						resolve(res)
					})
				})
			},
			initData() {
				this.$refs.loading.show()
				this.queryYhData({ status: this.yhStu }).then(res => {
					this.yhALlDetail = res.num
					const data = JSON.parse(res.data)
					for (let item of data) {
						if (!item.xyz) {
							item.xyz = '110.293561,20.007969'
						}
					}
					this.qyyhDetail = data[1]
					this.yhList = data
					this.init(data)
				})
			},
			yhqh(item, index) {
				this.querykeyword = ''
				this.sType == 1
				if (this.sType == 2) return
				this.leftitem = index
				if (index == 0) {
					this.lxId = ''
					this.initData()
					this.getStatusCount()
					this.allAcountQy()
				} else {
					this.lxId = item.id
					this.initData()
					this.getStatusCount()
					this.allAcountQy()
				}
				if (this.yhList.length) {
					this.openW(this.yhList[0], 0)
				}
			},
			yhqiy(item, index) {
				this.leftitem = index
				if (index == 0) {
					this.lxId = ''
					this.initqiy()
					this.getStatusCount()
					this.allAcountQy()
				} else {
					this.lxId = item.id
					this.initqiy()
					this.getStatusCount()
					this.allAcountQy()
				}
			},
			openqy(item, c) {
				console.log('openitme', item)
				this.querykeyword = ''
				this.rightitem = c
				const xy = item.center
				const LngLat = new T.LngLat(xy[0], xy[1])
				const infoWindow = new T.InfoWindow(alertMapQy(item))
				infoWindow.addEventListener('open', e => {
					const h = e.target.UT.clientHeight
					infoWindow.setOffset(new T.Point(0, h / 2 + 60))
				})
				this.tMap.panTo(LngLat)
				this.tMap.openInfoWindow(infoWindow, LngLat)
			},
			openqiy(item, c) {
				this.querykeyword = ''
				//构建信息窗体中显示的内容
				this.rightitem = c
				const e = {
					lnglat: {
						lng: item.xyz.split(',')[0],
						lat: item.xyz.split(',')[1]
					}
				}
				this.openWindow(this.tMap, item, e)
			},
			openJr(item, c) {
				this.querykeyword = ''
				this.rightitem = c
				const infoWindow = new T.InfoWindow(alertMapJr(item))
				infoWindow.addEventListener('open', e => {
					const h = e.target.UT.clientHeight
					infoWindow.setOffset(new T.Point(0, h / 2 + 60))
				})
				const xy = item.xyz.split(',')
				const LngLat = new T.LngLat(xy[0], xy[1])
				this.tMap.panTo(LngLat)
				this.tMap.openInfoWindow(infoWindow, LngLat)
			},
			openW(item, c) {
				//构建信息窗体中显示的内容
				this.rightitem = c
				const infoWindow = new T.InfoWindow(alertMap(item))
				infoWindow.addEventListener('open', e => {
					const h = e.target.UT.clientHeight
					infoWindow.setOffset(new T.Point(0, h / 2 + 60))
				})
				const xy = item.xyz.split(',')
				const LngLat = new T.LngLat(xy[0], xy[1])
				this.tMap.panTo(LngLat)
				this.tMap.openInfoWindow(infoWindow, LngLat)
			},
			addMarker(list, map) {
				// 点位
				for (const i of list) {
					const xy = i.xyz.split(',')
					const LngLat = new T.LngLat(xy[0], xy[1])
					const mark = new T.Marker(LngLat, {
						icon: new T.Icon({
							iconUrl: jj,
							iconSize: [40, 40]
						})
					})
					let info = ''
					if (this.sType == 5) {
						info = alertMapJr(i)
					} else {
						info = alertMap(i)
					}
					const infoWindow = new T.InfoWindow(info, [{ maxWidth: 400 }])
					infoWindow.addEventListener('open', e => {
						console.log('e', e)
						const h = e.target.UT.clientHeight
						infoWindow.setOffset(new T.Point(0, h / 2 + 60))
					})
					mark.addEventListener('click', () => {
						map.panTo(LngLat)
						mark.openInfoWindow(infoWindow)
					})
					map.addOverLay(mark)
				}
			},
			async init(list) {
				console.log('执行')
				await this.$nextTick()
				this.$refs.loading.show()
				const map = this.tMap
				map.clearOverLays()
				var pathArray = [
					new T.LngLat(-360, 90),
					new T.LngLat(-360, -90),
					new T.LngLat(360, -90),
					new T.LngLat(360, 90)
				]
				// 秀英区边框
				var Polygon = new T.Polygon([pathArray, areapath.map(val => new T.LngLat(val[0], val[1]))], {
					weight: 2,
					color: '#32d4fc',
					fillColor: '#001937',
					fillOpacity: 0.7
				})
				map.addOverLay(Polygon)

				// 初始化 labelMarker
				if (this.sType == 1 || this.sType == 3 || this.sType == 5) {
					this.addMarker(list, map)
				} else if (this.sType == 4) {
					this.addQiYMarker(list, map)
				}
				// //画镇行政片区
				for (const i of arealist.xyArea) {
					let polygonArea = new T.Polygon(
						i.points.map(val => new T.LngLat(val[0], val[1])),
						{
							weight: 1,
							fillOpacity: 0.2,
							fillColor: i.color
						}
					)
					const center = new T.LngLat(i.center[0], i.center[1])
					const infoWindow = new T.InfoWindow(alertMapQy(i))
					infoWindow.addEventListener('open', e => {
						const h = e.target.UT.clientHeight
						infoWindow.setOffset(new T.Point(0, h / 2 + 100))
					})
					polygonArea.addEventListener('click', () => {
						map.panTo(center)
						map.openInfoWindow(infoWindow, center)
					})
					map.addOverLay(polygonArea)

					const area = new T.Marker(center, { zIndexOffset: 100 })
					area.addEventListener('click', () => {
						map.panTo(center)
						area.openInfoWindow(infoWindow)
					})
					map.addOverLay(area)
				}
				if (this.sType == 1 || this.sType == 3) {
					this.openW(list[0], 0)
				} else if (this.sType == 2) {
					this.openqy(list[0], 0)
				} else if (this.sType == 4) {
					this.openqiy(list[0], 0)
				} else if (this.sType == 5) {
					this.openJr(list[0], 0)
				}
				this.$refs.loading.hide()
			}
		}
	}
</script>

<style lang="scss" scoped>
	$white-color: #358fe6;
	$white-bg-color: #fff;
	$white-text-color: #333;
	$white-fz-color: #999;
	.ctrl {
		position: fixed;
		right: 356px;
		bottom: 20vh;
		cursor: pointer;
		> div {
			background-color: #10979b;
			width: 30px;
			height: 30px;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 20px;
			font-weight: bold;
			margin: 5px 0;
		}
	}
	.check-color {
		position: fixed;
		right: 356px;
		bottom: 12vh;
		.chack-color-li {
			display: flex;
			align-items: center;
			margin-top: 12px;
			background-color: #0000002e;
			padding-right: 8px;
			cursor: pointer;
			.check-or {
				display: inline-block;
				width: 21px;
				height: 21px;
				border: 1px solid #10979b;
				position: relative;
				margin-right: 8px;
				&.active {
					color: aquamarine;
					&:after {
						content: '\2713';
						background-color: #10979b;
						color: #fff;
						position: absolute;
						top: 0;
						left: 0;
						display: inline-block;
						width: 21px;
						height: 21px;
					}
				}
			}
		}
	}
	.alertNew {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba($color: #000000, $alpha: 0.5);
		z-index: 10000;
		display: flex;
		justify-content: center;
		align-items: center;
		.center-alert {
			// margin: auto;
			height: 60vh;
			// width: calc(58vw - 80px);
			background-image: url(../assets/img/tkbj.png);
			background-repeat: no-repeat;
			background-size: 100% 100%;
			background-color: #154242c7;
			display: flex;
			flex-flow: column;
			.alert-title {
				position: relative;
				height: 42px;
				width: 100%;
				margin: auto;
				font-size: 24px;
				padding: 8px 0;
				text-align: center;
				background-image: url(../assets/img/listbg.png);
				background-repeat: no-repeat;
				background-size: 100% 100%;
				color: #4cbfce;
				font-weight: 600;
				line-height: 42px;
			}
			.center {
				height: 100%;
				overflow-y: scroll;
				padding: 10px 20px;
				padding-bottom: 0;
				text-align: start;
			}
			&.small {
				.center {
					.iconfont {
						margin: 0 12px;
						color: #4cbfce;
					}
					.yan-title {
						// width: calc(100% - 60px);
						background-color: #106d7563;
						padding-left: 8px;
						margin-bottom: 12px;
						padding: 0 8px;
						font-size: 18px;
					}
					.yan-lc {
						margin-bottom: 12px;
						line-height: 34px;
						div {
							padding: 0 8px;
							// background-color: darkcyan;
							// margin-top: 8px;
						}
					}
				}
			}
		}
	}
	.home {
		color: white;
		.title-name {
			color: #fff;
			// color: #fad514;
			font-size: 26px;
			margin-bottom: 8px;
		}
		.amap-marker-content {
			white-space: inherit !important;
		}
		#mapContainer {
			width: 100%;
			height: 100vh;
			z-index: 0;
		}
		.pagetitle {
			position: fixed;
			top: 0;
			left: 0;
			width: calc(100% - 36px);
			height: 78px;
			display: flex;
			justify-content: space-between;
			padding: 0 18px;
			// line-height: 100px;
			font-size: 18px;
			background-image: url(../assets/img/topbg.png);
			background-repeat: no-repeat;
			background-position: center;
			background-size: 100% 100%;
			opacity: 0.8;
			align-items: center;
			> div {
				width: 33%;
			}
			.time {
				margin-top: -33px;
				text-align: left;
			}
		}
		.pagetitle .wether {
			margin-top: -33px;
		}
		.pages-lef-r {
			position: fixed;
			left: 112px;
			max-height: 80vh;
			overflow-y: scroll;
			border-radius: 4px;
			top: 12vh;
			width: 30px;
			background-image: url(../assets/img/outlistbg.png);
			background-repeat: no-repeat;
			background-size: 100% 100%;
			background-color: #266a72a8;
		}
		.list-page-title {
			height: 32px;
			// margin-top: 6px;
			line-height: 32px;
			width: calc(100% - 4px);
			margin: 2px auto 0;
			background-image: url(../assets/img/lxbj.png);
			background-repeat: no-repeat;
			background-size: 100% 100%;
		}
		.list-page-c {
			height: calc(100% - 32px);
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			.pages-li {
				// height: 42px;
				padding: 12px 0;
				width: 100%;
				display: flex;
				align-items: center;
				&:hover,
				&.active {
					cursor: pointer;
					background-image: url(../assets/img/leftcheckbg.png);
					background-repeat: no-repeat;
					background-size: 100% 112%;
					background-position-y: -8px;
				}
				// flex-direction: column;
				// justify-content: space-between;
				// margin-top: 40px;
				.pages-li-n {
					width: 104px;
				}
				.line- {
					width: calc(100% - 104px);
					background-color: #266a7266;
					height: 42px;
					position: relative;
					.sl {
						width: 30%;
						height: 100%;
						background-color: #10979b;
					}
					.sl-name {
						position: absolute;
						left: 0;
						top: 0;
						width: 100%;
						height: 100%;
						line-height: 42px;
						text-align: center;
					}
				}
			}
		}
		.pageleft {
			position: fixed;
			left: 18px;
			width: 86px;
			height: 90vh;
			background-image: url(../assets/img/outlistbg.png);
			background-repeat: no-repeat;
			background-size: 100% 100%;
			background-color: #266a72a8;
			color: #62fdff;
			display: flex;
			flex-direction: column;
			top: 8vh;
			z-index: 100;
			overflow-y: scroll;
			.item {
				flex-shrink: 0;
				font-size: 14px;
				height: 85px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				position: relative;
				&.active,
				&:hover {
					background-image: url(../assets/img/leftcheckbg.png);
					background-repeat: no-repeat;
					background-size: 107% 100%;
					background-position: -2px;
					cursor: pointer;
				}
				span {
					position: absolute;
					right: 0px;
					top: 8px;
					display: inline-block;
					padding: 0 4px;
					background-color: red;
					color: #fff;
					border-radius: 9px;
					font-weight: 600;
				}
			}
		}
		.pageright {
			position: absolute;
			right: 18px;
			width: 320px;
			height: 80vh;
			top: 12vh;
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			text-align: start;
			.check-btn {
				width: 100%;
				height: 48px;
				display: flex;
				justify-content: space-between;
				background-image: url(../assets/img/checkbg.png);
				background-repeat: no-repeat;
				background-size: 100% 100%;
				& .btn-l,
				& .btn-r {
					width: 50%;
					text-align: center;
					height: 48px;
					line-height: 48px;
					font-size: 18px;
					color: #333;
					font-weight: 600;
				}
				&.cactive {
					background-image: url(../assets/img/checkbg1.png);
				}
			}
			.pglist {
				.allr-list {
					flex-grow: 1;
					// max-height: 66%;
					overflow: auto;
					width: 100%;
					&::-webkit-scrollbar {
						/*滚动条整体样式*/
						width: 0; /*高宽分别对应横竖滚动条的尺寸*/
					}
				}
				margin-top: 12px;
				height: calc(100% - 60px);
				width: 100%;
				background-image: url(../assets/img/tkbj.png);
				background-repeat: no-repeat;
				background-size: 100% 100%;
				background-color: #1542424f;
				.itemlist {
					width: calc(100% - 12px);
					height: calc(100% - 48px);
					border: 2px solid #4cbfce;
					margin: auto;
					display: flex;
					flex-flow: column;
					border: 2px solid $white-fz-color;
				}
				.item {
					display: flex;
					border-bottom: 1px solid #229fa1;
					height: 42px;
					&.active,
					&:hover {
						background-color: #02696da6;
						cursor: pointer;
					}
				}
				.item-nam,
				.item-li {
					font-size: 14px;
					padding: 2px;
					border: 1px solid #4cbfce;
					// display: flex;
					// justify-content: center;
					// align-items: center;
					line-height: 42px;
					overflow: hidden; /*自动隐藏文字*/
					text-overflow: ellipsis; /*文字隐藏后添加省略号*/
					white-space: nowrap; /*强制不换行*/
				}
				.item-nam {
					width: 60%;
					position: relative;
					.dian {
						display: inline-block;
						width: 6px;
						height: 6px;
						background-color: rgb(255, 196, 0);
						border-radius: 50%;
						position: absolute;
						top: 8px;
						right: 8px;
					}
				}
				.list-th {
					// margin-top: 12px;
					// padding: 12px;
					border-bottom: 1px solid #229fa1;
					.item-nam,
					.item-li {
						padding: 0px 6px;
						border-bottom: 0;
						line-height: 42px;
						// text-align: center;
						display: flex;
						justify-content: center;
						align-items: center;
						// line-height: 42px;
						// border: 1px solid #229fa1;
					}
					.item-nam {
						width: calc(60% - 12px);
						background-image: url(../assets/img/listthbg1.png);
						background-repeat: no-repeat;
						background-size: calc(100% - 4px) calc(100% - 4px);
						background-position-x: 2px;
						background-position-y: 2px;
					}
					.item-li {
						width: calc(40% - 12px);
						// margin-left: 8px;
						background-image: url(../assets/img/listthbg2.png);
						background-repeat: no-repeat;
						background-size: calc(100% - 4px) calc(100% - 4px);
						background-position-x: 2px;
						background-position-y: 2px;
						// border-left: 1px solid #229fa1;
					}
				}
				.item-li {
					width: 40%;
					// text-align: center;
				}
				.pageright-title {
					text-align: center;
					padding: 6px 0;
					margin: 4px 4px 0;
					// line-height: 36px;
					width: calc(100% - 8px);
					// color: #25bbb7;
					font-size: 16px;
					font-weight: 600;
					// border-bottom: 1px solid #ddd;
					background-image: url(../assets/img/listbg.png);
					background-repeat: no-repeat;
					background-size: 100% 100%;
				}
				.yhsb {
					flex-shrink: 0;
					border-top: 1px solid $white-text-color;
					width: 90%;
					padding: 0 5%;
					// margin: auto;
					height: 120px;
					display: flex;
					justify-content: space-between;
					border-top: 1px solid #4cbfce;
					.yhname {
						height: 100%;
						display: flex;
						justify-content: center;
						align-items: center;
						width: 40%;
					}
					.yhewm {
						width: 60%;
						display: flex;
						justify-content: center;
						align-items: center;
						.ewmtp {
							width: 80px;
							height: 80px;
							background-color: $white-fz-color;
						}
					}
				}
			}
		}

		.page-top {
			position: absolute;
			top: 90px;
			left: 24%;
			width: 53%;
			display: flex;
			.titlename {
				height: 32px;
				line-height: 32px;
				margin-top: 12px;
				color: #fff;
				font-size: 18px;
			}
			.item-t {
				background-repeat: no-repeat;
				background-size: 100% 100%;
				width: 263px;
				height: 120px;
				.number {
					height: 62px;
					width: 100%;
					color: #62fdff;
					line-height: 62px;
					padding-left: 8px;
					font-size: 34px;
					span {
						display: inline-block;
						background-image: url(../assets/img/numbg.png);
						background-repeat: no-repeat;
						background-size: 100% 100%;
						width: 38px;
						margin-right: 6px;
					}
				}
				&.item1 {
					background-image: url(../assets/img/topbg1.png);
				}
				&.item2 {
					background-image: url(../assets/img/topbg2.png);
				}
			}
		}
		.page-bottom {
			background-image: url(../assets/img/bootem.png);
			background-repeat: no-repeat;
			background-size: 100% 46%;
			position: fixed;
			background-position-y: 58px;
			bottom: 0px;
			left: 0;
			right: 0;
			margin: auto;
			width: calc(52% - 80px);
			height: 110px;
			display: -ms-flexbox;
			display: flex;
			-ms-flex-pack: distribute;
			justify-content: space-around;
			padding: 0 40px;
			.item-b {
				width: 120px;
				height: 120px;
				display: flex;
				flex-direction: column;
				align-items: center;
				cursor: pointer;
				.icon {
					width: 80px;
					height: 80px;
					background-image: url(../assets/img/btmbg.png);
					background-repeat: no-repeat;
					background-size: 100% 100%;
					display: flex;
					justify-content: center;
					align-items: center;
					.iconfont {
						color: #67b2bb;
						font-size: 32px;
					}
				}
				.item-name {
					color: #fff;
				}
			}
		}
		.iconfont {
			color: #fff;
		}

		.back-to {
			display: inline;
			position: absolute;
			right: 15px;
			top: -2px;
			font-size: 24px;
			color: #fff;
			cursor: pointer;
		}
		.search {
			width: calc(100% - 18px);
			border: 1px solid #10979b;
			padding: 8px;
			position: relative;
			input {
				width: calc(100% - 90px);
				height: 32px;
				border: 0;
				padding: 0 8px;
				background-color: #106d7563;
				border: 1px solid #10979b;
				border-radius: 4px;
				color: white;
				&::placeholder {
					color: #e6e6e6;
				}
			}
			span {
				display: inline-block;
				width: 60px;
				height: 32px;
				line-height: 32px;
				text-align: center;
				background-color: #106d7563;
				border: 1px solid #10979b;
				margin-left: 8px;
				border-radius: 4px;
				cursor: pointer;
				&:hover {
					background-color: #106d7583;
				}
			}
			.search-list {
				position: absolute;
				top: 46px;
				left: 10px;
				width: calc(100% - 90px);
				height: 320px;
				z-index: 999;
				overflow-y: auto;
				border-radius: 4px;
				border: 1px solid #10979b;
				background-color: #14636d;
				box-shadow: 0 3px 12px #ededed52;
				font-size: 15px;
				color: #f7f7f7;
				&::-webkit-scrollbar {
					width: 0;
				}
				.search-li {
					// height: 32px;
					line-height: 23px;
					padding: 4px;
					border-bottom: 1px solid #10979b;
					cursor: pointer;
				}
			}
		}
		.yh-all-list {
			height: calc(100% - 120px);
			overflow-y: auto;
			border-bottom: 1px solid #4cbfce;
		}
		.yh-list {
			display: flex;
			border: 1px solid #4cbfce;
			background-color: #1542424f;
			line-height: 38px;
			line-height: 26px;
			width: 60vw;
			margin: auto;
			.t1 {
				width: 8%;
				border-right: 1px solid #4cbfce;
				padding: 4px;
			}
			.t2 {
				width: 34%;
				border-right: 1px solid #4cbfce;
				padding: 4px;
			}
			.t3 {
				width: 34%;
				border-right: 1px solid #4cbfce;
				padding: 4px;
			}
			.t4 {
				width: 12%;
				border-right: 1px solid #4cbfce;
				padding: 4px;
				text-align: center;
			}
			.t5 {
				width: 12%;
				padding: 4px;
			}
			&.frysil {
				text-align: start;
				.t1 {
					text-align: center;
				}
			}
			&.th {
				padding: 0;
				> div {
					height: 32px;
					line-height: 32px;
					text-align: center;
				}
			}
		}
		.noneData {
			width: calc(100% - 12px);
			height: calc(100% - 120px);
			text-align: center;
			line-height: 120px;
			color: #4cbfce;
			border: 1px solid #4cbfce;
			margin: auto;
		}
		.line-heu {
			width: 100%;
			display: flex;
			padding: 6px;
			&.title {
				font-weight: 600;
				font-size: 18px;
				color: #62fdff;
			}
		}
		.detail-center {
			height: 100%;
			overflow-y: auto;
		}
	}
	::-webkit-scrollbar {
		width: 0;
	}

	.home.whiteColor {
		color: $white-text-color;
		.title-name {
			color: $white-color;
			font-weight: 600;
		}
		.time,
		.wether {
			color: $white-color;
			font-weight: 600;
		}
		.pagetitle {
			background-image: url(../assets/img/white/topbg.png);
			opacity: 1;
		}
		.pages-lef-r {
			background-color: $white-bg-color;
		}
		.list-page-title {
			background-image: none;
			border-bottom: 1px solid #666;
		}

		.pageleft {
			background-image: none;
			background-color: $white-bg-color;
			border: 1px solid $white-fz-color;
			color: $white-text-color;
			.item {
				border-bottom: 1px solid $white-fz-color;
				&.active,
				&:hover {
					background-image: none;
					color: $white-color;
					.iconfont {
						color: $white-color;
					}
					// background-repeat: no-repeat;
					// background-size: 107% 100%;
					// background-position: -2px;
				}
			}
		}
		.pageright {
			.check-btn {
				background-image: url(../assets/img/white/checkbg.png);
				background-repeat: no-repeat;
				background-size: 100% 100%;
				cursor: pointer;
				& .btn-l {
					color: $white-bg-color;
				}
				& .btn-r {
					color: $white-text-color;
				}
				&.cactive {
					background-image: url(../assets/img/white/checkbg1.png);
					& .btn-l {
						color: $white-text-color;
					}
					& .btn-r {
						color: $white-bg-color;
					}
				}
			}
			.pglist {
				background-image: none;
				background-color: $white-bg-color;
				.item {
					border-bottom: 1px solid $white-fz-color;
					&.active,
					&:hover {
						color: $white-color;
						background-color: #fff;
						cursor: pointer;
					}
				}
				.item-nam,
				.item-li {
					border: 1px solid $white-fz-color;
					border-bottom: 0;
					border-top: 0;
					border-left: 0;
				}
				.item-nam {
					width: 60%;
				}
				.list-th {
					border-bottom: 1px solid $white-fz-color;
					font-weight: 600;
					.item-nam {
						width: calc(60% - 12px);
						background-image: url(../assets/img/white/listthbg1.png);
						background-repeat: no-repeat;
						background-size: calc(100% - 4px) calc(100% - 4px);
						background-position-x: 2px;
						background-position-y: 2px;
						background-color: #f1f2f3;
					}
					.item-li {
						width: calc(40% - 12px);
						background-image: url(../assets/img/white/listthbg2.png);
						background-repeat: no-repeat;
						background-size: calc(100% - 4px) calc(100% - 4px);
						background-position-x: 2px;
						background-position-y: 2px;
						background-color: #f1f2f3;
					}
				}
				.item-li {
					width: 40%;
				}
				.pageright-title {
					background-image: none;
					background-color: $white-bg-color;
					background-image: url(../assets/img/white/pagetitle.png);
					background-repeat: no-repeat;
					background-size: 100% 30%;
					background-position-y: 54%;
				}
			}
		}

		.page-top {
			.titlename {
				color: $white-text-color;
				font-weight: 600;
				// text-shadow: 0 3px #f1f1f1;
			}
			.item-t {
				.number {
					color: $white-text-color;
					span {
						display: inline-block;
						background-image: none;
						border: 1px solid $white-fz-color;
						font-weight: 600;
						// background-repeat: no-repeat;
						// background-size: 100% 100%;
					}
				}
				&.item1 {
					background-image: url(../assets/img/white/topbg1.png);
				}
				&.item2 {
					background-image: url(../assets/img/white/topbg2.png);
				}
			}
		}
		.page-bottom {
			background-image: url(../assets/img/white/bootem.png);
			background-repeat: no-repeat;
			background-size: 100% 46%;
			.item-b {
				.icon {
					background-image: url(../assets/img/white/btmbg.png);
					background-repeat: no-repeat;
					background-size: 100% 100%;
					.iconfont {
						color: $white-text-color;
					}
				}
				.item-name {
					color: $white-text-color;
				}
			}
		}
		.iconfont {
			color: $white-text-color;
		}
		.center-alert {
			background-image: none;
			// background-repeat: no-repeat;
			// background-size: 100% 100%;
			background-color: $white-bg-color;
			.alert-title {
				background-image: url(../assets/img/white/pagetitle.png);
				background-repeat: no-repeat;
				background-size: 70% 29%;
				background-position: 50% 60%;
				color: $white-color;
				border-bottom: 1px solid $white-fz-color;
			}
			&.small {
				border: 1px solid $white-fz-color;
				.center {
					.iconfont {
						color: $white-color;
					}
					.yan-title {
						background-color: #e0e1e163;
					}
				}
			}
			.back-to {
				color: $white-text-color;
			}
		}
		.check-color {
			color: $white-bg-color;
			.chack-color-li {
				background-color: transparent;
				.check-or {
					border: 1px solid $white-bg-color;
					&.active {
						color: $white-bg-color;
						&:after {
							content: '\2713';
							background-color: $white-bg-color;
							color: $white-text-color;
						}
					}
				}
			}
		}
		.search {
			border: 1px solid $white-text-color;
			input {
				background-color: #cacaca63;
				border: 1px solid $white-fz-color;
				color: $white-text-color;
				&::placeholder {
					color: #9b9999;
				}
			}
			span {
				background-color: #cacaca63;
				border: 1px solid $white-fz-color;
				color: $white-text-color;
				&:hover {
					background-color: #bbbaba63;
				}
			}
		}
		.search-list {
			border: 1px solid $white-fz-color;
			background-color: $white-bg-color;
			box-shadow: 0 3px 12px #ededed52;
			color: $white-text-color;
			.search-li {
				border-bottom: 1px solid $white-fz-color;
			}
		}
		.yh-all-list {
			height: calc(100% - 120px);
			overflow-y: auto;
			border-bottom: 1px solid #4cbfce;
		}
		.yh-list {
			display: flex;
			border: 1px solid $white-fz-color;
			background-color: #dadada4f;
			width: calc(100% - 12px);
			line-height: 38px;
			margin: auto;
			.t1 {
				width: 8%;
				border-right: 1px solid $white-fz-color;
			}
			.t2 {
				width: 34%;
				border-right: 1px solid $white-fz-color;
			}
			.t3 {
				width: 34%;
				border-right: 1px solid $white-fz-color;
			}
			.t4 {
				width: 12%;
				border-right: 1px solid $white-fz-color;
			}
			.t5 {
				width: 12%;
			}
		}
		.noneData {
			color: $white-fz-color;
			border: 1px solid $white-fz-color;
		}
		.line-heu {
			&.title {
				color: $white-text-color;
			}
		}
	}
</style>
